export const mappingAddressData = (state, data) => {
  return {
    id: state.id,
    buildingName: data.buildingName,
    roomNumber: data.roomNumber,
    houseNumber: data.houseNumber,
    villageNumber: data.villageNumber,
    lane: data.lane,
    villageName: data.villageName,
    road: data.road,
    location: data.location,
    telephone: data.telephone,
    mobile: data.mobile,
    fax: data.fax,
    email: data.email,
  }
}
